import _ from "lodash";

import { MAX_TOTAL_NAME_LENGTH } from "../constants";

export const reducer = (previousState = initialState, action) => {
  switch (action.type) {
    case 'SET_STEP':
      return {
        ...previousState,
        step: action.stepNum,
      };
    case 'SET_FORM_DATA':
      const tempState = {
        ...previousState,
        formData: {
          ...previousState.formData,
          ...action.hash,
        }
      };

      if (tempState.formData.ownerAddressSameAsProperty === "true") {
        tempState.formData.ownerAddress = tempState.formData.propertyAddress;
      }
      if (action.hash.ownerAddressSameAsProperty === "false") {
        tempState.formData.ownerAddress = {};
      }

      tempState.formData.propertyOwnerLName = tempState.formData.propertyOwnerLName.slice(0, MAX_TOTAL_NAME_LENGTH)
      tempState.formData.propertyOwnerFName = tempState.formData.propertyOwnerFName.slice(0, MAX_TOTAL_NAME_LENGTH - tempState.formData.propertyOwnerLName.length)

      return tempState;
    case 'SHOW_MODAL':
      return {
        ...previousState,
        showModal: action.showModal
      };
    case 'SHOW_ERROR_MODAL':
      return {
        ...previousState,
        showErrorModal: action.showErrorModal
      };
    case 'IS_FETCHING':
      return {
        ...previousState,
        isFetching: action.isFetching
      };
    case 'SET_APP_DATA':
      return {
        ...previousState,
        appData: {
          ...previousState.appData,
          ...action.hash,
        }
      };
    case 'DISABLE_SUBMIT_BTN':
      return {
        ...previousState,
        disableSubmitBtn: action.disableSubmitBtn
      }
    case 'SET_VIAFORM':
      return {
        ...previousState,
        viaClaimForm: action.viaClaimForm
      }
    case 'SET_CLAIMDATA':
      return {
        ...previousState,
        claimData: action.claimData
      }
    default:
      return previousState;
  }
};
